import { FieldArray } from "@progress/kendo-react-form";
import { ListGrid } from "./DatasetGrid/List/DatasetListGrid";
import { datasetData } from "./NewDatasetSignals";

export const ListDataset = ({ formRenderProps, name }) => {
  return (
    <>
      <div className="white-section">
        <h2>List Data</h2>
        <div className="table-input-grid">
          <FieldArray
            name={name}
            component={ListGrid}
            values={datasetData.value.values.map((row) => row)}
            onChange={(newListData) => {
              datasetData.value = { ...datasetData.value, values: newListData };
              formRenderProps.onChange("listGrid", newListData);
            }}
          />
        </div>
      </div>
      {formRenderProps.errors.listGrid && (
        <div className="error">{formRenderProps.errors.listGrid}</div>
      )}
    </>
  );
};
